/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ClassroomdisciplineIdMaterialsMaterialidDownloadUrl200,
  GetApiV1ClassroomdisciplineIdMaterialsMaterialidDownloadUrl401,
  GetApiV1ClassroomdisciplineIdMaterialsMaterialidDownloadUrl404,
  GetApiV1ClassroomdisciplineIdMaterialsMaterialidDownloadUrlPathParams,
  GetApiV1ClassroomdisciplineIdMaterialsMaterialidDownloadUrlQueryResponse,
} from "../../types/classPlanningMaterialController/GetApiV1ClassroomdisciplineIdMaterialsMaterialidDownloadUrl.ts";
import { materialDownloadUrlViewModelSchema } from "../materialDownloadUrlViewModelSchema.ts";

export const getApiV1ClassroomdisciplineIdMaterialsMaterialidDownloadUrlPathParamsSchema =
  z.object({
    id: z.coerce.number().int(),
    materialId: z.coerce.number().int(),
  }) as unknown as ToZod<GetApiV1ClassroomdisciplineIdMaterialsMaterialidDownloadUrlPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ClassroomdisciplineIdMaterialsMaterialidDownloadUrl200Schema =
  z.lazy(
    () => materialDownloadUrlViewModelSchema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineIdMaterialsMaterialidDownloadUrl200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ClassroomdisciplineIdMaterialsMaterialidDownloadUrl401Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdMaterialsMaterialidDownloadUrl401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1ClassroomdisciplineIdMaterialsMaterialidDownloadUrl404Schema =
  z.any() as unknown as ToZod<GetApiV1ClassroomdisciplineIdMaterialsMaterialidDownloadUrl404>;

export const getApiV1ClassroomdisciplineIdMaterialsMaterialidDownloadUrlQueryResponseSchema =
  z.lazy(
    () => getApiV1ClassroomdisciplineIdMaterialsMaterialidDownloadUrl200Schema,
  ) as unknown as ToZod<GetApiV1ClassroomdisciplineIdMaterialsMaterialidDownloadUrlQueryResponse>;
